import React, { useEffect, useState } from "react";
import Login from "./Login";
import Home from "../pages/Home";
import { useMsal } from "@azure/msal-react";

const VerifyUsers = () => {
  const passtoken =
    !localStorage.getItem("access-token-storage") ||
    localStorage.getItem("access-token-storage") === null
      ? null
      : JSON.parse(localStorage.getItem("access-token-storage"))["accessToken"];
  const baseurl = `${process.env.REACT_APP_SERVER_URL}/aipd/getUserList `;
  const [userinfo, setuserinfo] = useState([]);
  const [isLoading, setIsloading] = useState(true);
  const [isAuth, setisauth] = useState(false);
  const { instance } = useMsal();

  useEffect(() => {
    if (passtoken === undefined || passtoken === null) {
      return; // or any default value you want to return in this case
    }
    fetchSearchByname();
  }, [passtoken]);

  const logout = async () => {
    // Will redirect to MSAL to end the session then redirect back to the configured `postLogoutRedirectUri`
    try {
      // Sign out the user
      // await instance.logoutRedirect({
      //   postLogoutRedirectUri: `${process.env.REACT_APP_SSO_LOGOUT_REDIRECT_URL}`, // Replace with your redirect URI
      // });
      localStorage.clear();
      window.location.href = `${process.env.REACT_APP_SSO_LOGOUT_REDIRECT_URL}`;
    } catch (error) {
      console.error("Logout failed", error);
    }
  };

  const fetchSearchByname = async () => {
    setIsloading(true);
    setisauth(false);
    await fetch(`${baseurl}`, {
      headers: {
        "oidc-token": passtoken,
        Accept: "application/json",
      },
    })
      .then((response) => {
        if (response.ok) {
          response.json().then((json) => {
            setuserinfo(json);
            setIsloading(false);
            const allemail = json && json.map((item) => item.emailAddress);
            const userEmail = localStorage.getItem("myemail");
            if (allemail.includes(userEmail)) {
              // Use `includes` instead of `include`
              setisauth(true);
            } else {
              setisauth(false);
              setTimeout(() => {
                logout();
              }, 3000);
            }
          });
        }
      })
      .catch((err) => {
        setuserinfo(null);
        setIsloading(false);
      });
  };

  useEffect(() => {
    if (passtoken === undefined || passtoken === null) {
      logout();
    }
  }, []);
  return (
    <div>
      {isLoading && (
        <div
          style={{
            height: "100vh",
            textAlign: "center",
            alignContent: "center",
            alignItems: "center",
          }}
        >
          {" "}
          Verifying users access to the tool please wait...
        </div>
      )}

      {!isLoading && isAuth && (
        <>
          <Home />
        </>
      )}

      {!isLoading && !isAuth && (
        <div style={{ height: "100vh" }}>
          <div
            style={{
              textAlign: "center",
              display: "grid",
              alignItems: "center",
              alignContent: "center",
              height: "100%",
            }}
          >
            <h1 class="w3-jumbo w3-animate-top w3-center">
              <code>Access Denied</code>
            </h1>
            <h4 class="w3-center w3-animate-right">
              You don't have permission to access this application. Please
              contact the tool administrator.
            </h4>
            <h3 class="w3-center w3-animate-zoom">🚫🚫🚫🚫</h3>
            <h6 class="w3-center w3-animate-zoom">error code:403 forbidden</h6>
          </div>
        </div>
      )}
    </div>
  );
};

export default VerifyUsers;
